"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightActionsSection = void 0;
var _auth = require("@ori/auth");
var _presentationHooks = require("@ori/presentation-hooks");
var _useShouldRenderNotificationMenu = require("../../hooks/useShouldRenderNotificationMenu");
var _FavoritesHeartIcon = require("../FavoritesHeartIcon");
var _Join = require("../Join");
var _NotificationBellIcon = require("../NotificationBellIcon");
var _SearchIcon = require("../SearchIcon");
var _SearchInput = require("../SearchInput");
var _ShoppingBagIcon = require("../ShoppingBagIcon");
var _SponsorInfo = require("../SponsorInfo");
var _UserSection = require("../UserSection");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const RightActionsSection = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const shouldShowNotificationMenu = (0, _useShouldRenderNotificationMenu.useShouldRenderNotificationMenu)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.RightActionsSectionRoot, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {
      showOnlyOn: "desktop"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchIcon.SearchIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SponsorInfo.GiftIcon, {}), isAnonymousUser && !isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Join.JoinIcon, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserSection.UserSection, {}), shouldShowNotificationMenu ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationBellIcon.NotificationBellIcon, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesHeartIcon.FavoritesHeartIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShoppingBagIcon.ShoppingBagIcon, {})]
  });
};
exports.RightActionsSection = RightActionsSection;
